import Modal from "../Modal/Modal";
import Button, { ButtonType } from "../Button/Button";
import BankTransferInfo from "./BankTransferInfo";

interface IProps {
  onCloseModal?: () => void;
  closeButtonName?: string;
}

const BankTransferInfoModal = (props: IProps) => {
  const { onCloseModal, closeButtonName = "Close" } = props;
  return (
    <Modal>
      <div className="bank-transfer-info-modal">
        <BankTransferInfo />
        <div className="actions">
          {onCloseModal && (
            <Button type={ButtonType.primary} onClick={onCloseModal}>
              {closeButtonName}
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default BankTransferInfoModal;
